<div class="container shadow-sm fill">
    <div class="p-3">
        <h3>Hallo! Das ist die Website der SchmidtCloud!</h3>
        Diese Seiten befinden sich noch im Aufbau
    </div>
</div>